define( 'views/app/drawer/editSettings',['views/app/drawer/itemSettingGroupCollection'], function( itemSettingGroupCollectionView ) {
	var view = Marionette.LayoutView.extend({
		tagName: 'div',
		template: '#tmpl-nf-drawer-content-edit-settings',

		regions: {
			settingTitle: '.nf-setting-title',
			settingGroups: '.nf-setting-groups'
		},

		initialize: function( data ) {
			this.dataModel = data.model;
			this.groupCollection = data.groupCollection;
		},

		onRender: function() {
			if( 'undefined' != typeof this.options.typeModel && 'undefined' != typeof this.options.typeModel.id ) {
				// Set the object domain for advanced settings groups.
				this.model.set( 'objectDomain', this.options.typeModel.id );
			}
			var currentDomain = nfRadio.channel( 'app' ).request( 'get:currentDomain' );
			var titleView = currentDomain.get( 'getSettingsTitleView' ).call( currentDomain, { model: this.model } );

			this.settingTitle.show( titleView );
			this.settingGroups.show( new itemSettingGroupCollectionView( { collection: this.groupCollection, dataModel: this.dataModel } ) );
		},

		templateHelpers: function () {
	    	return {
	    		maybeRenderTitle: function() {
	    			if ( 'undefined' !== typeof this.type ) {
	    				var title = nfRadio.channel( 'app' ).request( 'get:template',  '#tmpl-nf-drawer-content-edit-settings-title' );
	    				return title( this );
	    			} else {
	    				return '';
	    			}
	    		},

	    		renderTypeNicename: function() {
	    			var currentDomain = nfRadio.channel( 'app' ).request( 'get:currentDomain' );
					var domainID = currentDomain.get( 'id' );
	    			var type = nfRadio.channel( domainID ).request( 'get:type', this.type );
	    			return type.get( 'nicename' );
				},
			};
		},
	});

	return view;
} );
